import { z } from 'zod';
import { cursorPageSchema, isoDateTimeSchema, uuidSchema } from './common.js';
import { notificationTypeSchema } from './enums.js';
export const notificationSchema = z.object({
    id: uuidSchema,
    type: notificationTypeSchema,
    /** Text in the language the recipient had when it was created – the fallback. */
    title: z.string(),
    body: z.string().nullable(),
    /** Render `notifications.messages.<messageKey>` with `params` when the client knows the key. */
    messageKey: z.string().nullable().optional(),
    params: z
        .record(z.union([z.string(), z.number()]))
        .nullable()
        .optional(),
    data: z.record(z.unknown()).nullable(),
    readAt: isoDateTimeSchema.nullable(),
    createdAt: isoDateTimeSchema,
});
export const notificationPageSchema = cursorPageSchema(notificationSchema).extend({
    unreadCount: z.number().int(),
});
export const pushSubscriptionRequestSchema = z.object({
    endpoint: z.string().url(),
    keys: z.object({ p256dh: z.string(), auth: z.string() }),
    userAgent: z.string().max(300).optional(),
});
export const pushConfigSchema = z.object({
    enabled: z.boolean(),
    vapidPublicKey: z.string().nullable(),
});
//# sourceMappingURL=notifications.js.map